import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { BlahService } from '@headpower/blah-ng';
import { ToasterService } from '@headpower/layout';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class FavoritesService {
    private readonly http = inject(HttpClient);
    private readonly favoritesUrl: string = `${environment.backendPortalUri}Portal.WebAPI/Favorites`;
    private readonly favoritesCustomerAdminUrl: string = `${environment.backendPortalUri}CustomerAdminWebAPI/Favorites`;
    private readonly blahService = inject(BlahService);
    private readonly toaster = inject(ToasterService);

    private _favoritesSignal = signal([]);
    public favoriteLists = this._favoritesSignal.asReadonly();

    public setFavoriteLists(lists: any[]) {
        this._favoritesSignal.set([...(lists ?? [])]);
    }

    private _currentUser = signal({});
    public currentUser = this._currentUser.asReadonly();

    public setCurrentUser(user: any) {
        this._currentUser.set({ ...(user ?? {}) });
    }

    public fetchFavorites(): void {
        this.getUserFavoriteListsWithFavorites().subscribe({
            next: (data) => {
                const ownCompanyFavoriteLists = data.filter((list: any) => !list.SharerCompanyId || list.SharerCompanyId === this.currentUser()['companyId']);
                const instructionFavorites = ownCompanyFavoriteLists.filter(list => list.Type === 'IWI_Instruction');

                const favoriteLists = this.currentUser()['isCustomerAdmin']
                    ? instructionFavorites
                    : instructionFavorites.filter(list => list.UserId === this.currentUser()['userId']);

                this.setFavoriteLists(favoriteLists);
            }, error: (error) => {
                this.toaster.create(this.blahService.blah('error.favorites.getUserFavoriteListsWithFavorites'));
            }
        });
    }

    public getUserFavoriteListsWithFavorites(): Observable<any> {
        const url = `${this.favoritesUrl}/GetUserFavoriteListsWithFavorites`;
        return this.http.get(url);
    }

    public createUserFavoriteList(list: any): Observable<any> {
        const url = `${this.favoritesUrl}/CreateUserFavoriteList`;
        return this.http.post(url, list);
    }

    public createUserFavoriteToList(favorite: any): Observable<any> {
        const url = `${this.favoritesUrl}/CreateUserFavoriteToList`;
        return this.http.post(url, favorite);
    }

    public deleteUserFavoriteFromList(favorite: any): Observable<any> {
        const url = `${this.favoritesUrl}/DeleteUserFavoriteFromList`;
        return this.http.delete(url, { body: favorite });
    }

    public createUserFavoriteToSharedList(favorite: any): Observable<any> {
        const url = `${this.favoritesCustomerAdminUrl}/CreateUserFavoriteToSharedList`;
        return this.http.post(url, favorite);
    }

    public deleteUserFavoriteFromSharedList(favorite: any): Observable<any> {
        const url = `${this.favoritesCustomerAdminUrl}/DeleteUserFavoriteFromSharedList`;
        return this.http.delete(url, { body: favorite });
    }
}
